module.exports = __webpack_public_path__ + "static/img/btn-message.b7a2985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/btn-message.png
// module id = e+Y5
// module chunks = 1